// Ключевые слова (СТО 3.2.6 - 5–15 слов или словосочетаний из текста работы в именительном падеже, строчными,
// через запятые; 3.12.2 - свойство Keywords файла): подбор по тексту на сервере (POST /api/sto/keywords ->
// web/server/stoweb/keywords.py, lib/sto_keywords.py). Подобранные автоматически помечаются meta.keywords_auto -
// редактор просит автора проверить их; любая правка списка автором снимает пометку.
import type { Ctx } from '../../core/registry';
import type { Meta } from '../../core/types';

export interface KeywordSuggestion {
  /** подобранные по теме, заголовкам, подписям и тексту (пусто - надёжно подобрать не удалось) */
  keywords: string[];
  /** перечень «Ключевые слова: …», найденный в тексте реферата/аннотации (его автор уже написал) */
  front: string[] | null;
}

/** Подобрать по текущему тексту (с несохранёнными правками). */
export function suggestKeywords(ctx: Ctx, meta: Meta): Promise<KeywordSuggestion> {
  const doc = ctx.editor?.getJSON() || { type: 'doc', content: [] };
  return ctx.api.post<KeywordSuggestion>('/api/sto/keywords', { meta, doc });
}

const norm = (s: string) => s.trim().toLowerCase().replace(/ё/g, 'е');

/** Применить подбор к метаданным: пустой или ранее подобранный список заменяется, заданный автором - только
 * дополняется недостающими (до 15). Возвращает новые метаданные и число добавленных слов. */
export function applySuggestion(m: Meta, r: KeywordSuggestion): { meta: Meta; added: number; replaced: boolean } {
  const fromFront = !!(r.front && r.front.length);
  const got = (fromFront ? r.front! : r.keywords) || [];
  if (!got.length) return { meta: m, added: 0, replaced: false };
  if (!m.keywords.length || m.keywords_auto) {
    return { meta: { ...m, keywords: got.slice(0, 15), keywords_auto: !fromFront }, added: got.length, replaced: true };
  }
  const have = new Set(m.keywords.map(norm));
  const extra = got.filter((k) => !have.has(norm(k))).slice(0, Math.max(0, 15 - m.keywords.length));
  return { meta: { ...m, keywords: [...m.keywords, ...extra] }, added: extra.length, replaced: false };
}

/** Подобрать и записать в «Данные работы» (замечание проверки «Нет ключевых слов» -> «Подобрать»). */
export async function fillKeywords(ctx: Ctx): Promise<void> {
  const m = ctx.store.getState().meta;
  if (!m) return;
  try {
    const r = await suggestKeywords(ctx, m);
    const res = applySuggestion(m, r);
    if (!res.added) {
      ctx.toast('По тексту работы надёжно подобрать ключевые слова не удалось - впишите 5–15 слов сами', 'warn', 6000);
      void ctx.openDialog('sto.meta', { tab: 'work', field: 'keywords' });
      return;
    }
    ctx.store.getState().setMeta(() => res.meta);
    ctx.toast(r.front?.length ? 'Ключевые слова взяты из реферата' : `Ключевые слова подобраны по тексту (${res.added}) - проверьте их в «Данные работы»`, 'ok', 6000);
  } catch (e) {
    ctx.toast('Не удалось подобрать ключевые слова: ' + String((e as Error)?.message || e), 'error');
  }
}
